import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const iaregistrationstepGuard: CanActivateFn = (route, state) => {
  // Get the Router instance (injected functionally)
  const router = inject(Router);

  // Get the current URL (to know which route the user is trying to access)
  const currentUrl = state.url;

  // Function to check if the previous step was completed
  const checkPreviousStep = (url: string): boolean => {
    switch (url) {
      case '/iaregister':
        return !!sessionStorage.getItem('registerUserAsCompleted');
      case '/iapreviewpage':
        return !!sessionStorage.getItem('iaRegisterCompleted');
      default:
        return true; // Allow access to the first page (e.g., /registeruseras)
    }
  };

  // Function to get the previous step's route to redirect the user
  const getPreviousStep = (url: string): string => {
    switch (url) {
      case '/iaregister':
        return '/registeruseras';
      case '/iapreviewpage':
        return '/iaregister';
      default:
        return '/login';  // Default to the first page if the URL doesn't match
    }
  };

  // Check if the user has completed the previous step
  const previousStepCompleted = checkPreviousStep(currentUrl);

  if (!previousStepCompleted) {
    // If the previous step is not completed, redirect to the previous step
    router.navigate([getPreviousStep(currentUrl)]);
    return false;  // Prevent access to the current route
  }

  return true;  // Allow access to the current route if the previous step is completed
};
